import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('React Error Boundary caught an error:', error, errorInfo);
    document.title = 'ERROR CAUGHT - ' + error.message;
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          backgroundColor: '#fee2e2',
          border: '3px solid #dc2626',
          margin: '20px',
          fontFamily: 'monospace',
          fontSize: '16px'
        }}>
          <h1 style={{ color: '#dc2626', fontSize: '24px', marginBottom: '20px' }}>
            🔴 React Error Caught!
          </h1>
          <p><strong>Error:</strong> {this.state.error?.message}</p>
          <pre style={{ 
            backgroundColor: '#fef2f2', 
            padding: '15px', 
            marginTop: '15px',
            border: '1px solid #dc2626',
            fontSize: '14px',
            overflow: 'auto'
          }}>
            {this.state.error?.stack}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}